import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField'
import { tryParse } from '../../../app/common/useful';

const QuantityInput = ({ measure, quantity, defaultMax = 100, onChange }) => {
    const [amount, setAmount] = useState(tryParse(quantity, 0));

    const handleChange = value => {
        const qty = tryParse(value, 0);
        setAmount(qty);
        onChange(qty);
    }

    return (
        <TextField
            style={{ minWidth: '100%' }}
            value={amount}
            type="number"
            helperText={`${measure}s`}
            inputProps={{
                min: 0,
                max: defaultMax,
                
            }}
            onChange={({ target: { value } }) => handleChange(value)}
        />);
}

export default QuantityInput;